const IMPORT_TYPES = {
  insert: 'insert',
  update: 'update',
  upsert: 'upsert',
}

export default IMPORT_TYPES
